import { render, staticRenderFns } from "./SSelectPayrollAllow.vue?vue&type=template&id=20fec46a"
import script from "./SSelectPayrollAllow.vue?vue&type=script&lang=js"
export * from "./SSelectPayrollAllow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports